import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ChapterApiService} from '../api/chapter-api.service';
import {ToastrService} from 'ngx-toastr';
import {CommitteeDTO, CommitteeService} from '../api/committee-api.service';
import {UserApiService} from '../api/user-api.service';
import {COMMITTEE_ROLES, MEMBERSHIP_TYPE, USER_ROLES} from '../constants';
import {SharedService} from '../api/shared-service';
import {SpinnerService} from '../shared/services/spinner.service';
import {finalize} from 'rxjs';
import {RoleScope, reachesAllChapters, reachesChapter, storedRoleScope} from '../shared/access';
@Component({
    selector: 'app-update-user',
    templateUrl: './update-user.component.html',
    styleUrl: './update-user.component.css'
})
export class UpdateUserComponent {
    showCommittee = true;
    chapterId!: string;
    chapterList: any[] = [];
    memberForm: FormGroup;
    chapterUsers: any[] = [];
    chapter: any;
    chapterCreationError = false;
    committeeMembers: any;
    uploadedImageUrl: string | null = null;
    userChapter: any;
    committees: CommitteeDTO[] = [];
    selectedCommittee?: CommitteeDTO;
    committeId: any;
    selectedMember: any;
    userRole: any;
    userGroup: any;
    roleScope: RoleScope = storedRoleScope();

    /** True for roles whose reach is every chapter (system administrator and the NEC tier), as decided by the API. */
    get allChapters(): boolean {
        return reachesAllChapters(this.roleScope);
    }
    commiteeroles = COMMITTEE_ROLES;
    userRoles = USER_ROLES;
    membershipType = MEMBERSHIP_TYPE
    showUserDropdown = false;
    filteredUsers: any[] = [];
    pendingMembers: any[] = [];
    page: number = 1;
    selectedUserProfile: any = null;
    fullProfileForm: FormGroup;
    fullProfileUserId: string | null = null;
    fullProfileSubmitted = false;
    readonly fullProfileLabels: Record<string, string> = {
        firstname: 'First Name', lastname: 'Last Name', email: 'Email', phone: 'Contact Phone',
        chapterAffiliation: 'Chapter', sex: 'Sex', maritalStatus: 'Marital Status', userGotra: 'Gotra',
        userSubCast: 'Sub Caste', addressLine1: 'Address Line 1', city: 'City', state: 'State',
        zipCode: 'Zip Code', country: 'Country'
    };
    loadingProfile = false;

    constructor(private route: ActivatedRoute,
                private sharedService: SharedService,
                private fb: FormBuilder,
                private toastr: ToastrService,
                private chapterApiService: ChapterApiService,
                private committeeService: CommitteeService,
                private usereApiService: UserApiService,
                private router: Router,
                private spinner: SpinnerService
    ) {

        this.memberForm = this.fb.group({
            role: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            memberType: ['', Validators.required],
            chapterAffiliation: ['', Validators.required],
            id: ['', Validators.required] // Add id field for user selection
        });
        // Same fields as the member's own Personal Info page (profile component), minus password.
        this.fullProfileForm = this.fb.group({
            firstname: ['', Validators.required],
            lastname: ['', Validators.required],
            companyName: [''],
            phone: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            addressLine1: ['', Validators.required],
            addressLine2: [''],
            city: ['', Validators.required],
            state: ['', Validators.required],
            zipCode: ['', Validators.required],
            country: ['', Validators.required],
            spouseName: [''],
            spouseEmailId: [''],
            spousePhoneNumber: [''],
            kidsName: [''],
            kidDetails: this.fb.array([]),
            aboutMe: [''],
            // required to match the member's own Personal Info page
            sex: ['', Validators.required],
            maritalStatus: ['', Validators.required],
            userGotra: ['', Validators.required],
            userSubCast: ['', Validators.required],
            chapterAffiliation: ['', Validators.required]
        });


        this.chapterId = this.route.snapshot.paramMap.get('id')!;
        this.userChapter = sessionStorage.getItem('chapter');
        this.spinner.show(); // Show spinner while loading chapters
        this.sharedService.userRole$.subscribe((role) => {
            if (typeof role === 'string') {
                this.userRole = JSON.parse(role || '{}');
            } else {
                this.userRole = role;
            }
        });

        this.chapterApiService.getData().pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe(
            (response) => {

                this.chapterList = response;
                ;
            },
            (error) => {
                // Handle login error (invalid credentials, server error, etc.)
                console.error('Failed to load chapters', error);

            }
        );

    }

    ngOnInit(): void {

        this.chapterId = this.route.snapshot.paramMap.get('id')!;
        this.userChapter = sessionStorage.getItem('chapter');

        this.userRole = JSON.parse(sessionStorage.getItem('rolesPermission') || '{}');

        this.userGroup = sessionStorage.getItem('userGroup') || '{}';
        this.roleScope = storedRoleScope();

        this.loadUsers();

    }


    viewProfile(userId: string) {
        this.loadingProfile = true;
        this.selectedUserProfile = null;

        this.spinner.show();

        this.usereApiService.getData(userId).pipe(
            finalize(() => {
                this.loadingProfile = false;
                this.spinner.hide();
            })
        ).subscribe({
            next: (res: any) => {
                this.selectedUserProfile = res;
                this.chapterApiService.getChapterData(this.selectedUserProfile.chapterAffiliation).subscribe(
                    (response) => {
                       this.selectedUserProfile.chapterAffiliation = response.name||'';
                    }
                );


            },
            error: (err) => {
                console.error('Failed to load user profile', err);
                this.toastr.error('Failed to load user profile');
            }
        });
    }


    approveMembership(user: any) {
        this.usereApiService.updateProfile(user.id, {memberType: 'MEMBER', role: 'MEMBER'}).subscribe({
            next: () => {
                this.toastr.success(`${user.firstname} ${user.lastname} membership approved!`);
                // Update the list to remove approved user
                this.pendingMembers = this.pendingMembers.filter(u => u.id !== user.id);
            },
            error: (err) => {
                console.error('Failed to approve membership', err);
                this.toastr.error('Failed to approve membership');
            }
        });
    }

    updateUserMember() {

        this.memberForm.reset({
            email: '',
            role: '',
            memberType: '',
            chapterAffiliation: '',
            id: ''
        });
        this.filteredUsers = [];
        this.showUserDropdown = false;
    }


    onEmailInput() {
        const input = this.memberForm.get('email')?.value?.toLowerCase() || '';
        this.filteredUsers = this.chapterUsers.filter(user =>
            (user.firstname + ' ' + user.lastname + ' ' + user.email).toLowerCase().includes(input)
        );
        this.showUserDropdown = !!input && this.filteredUsers.length > 0;
    }

    selectUser(user: any) {
        //this.memberForm.patchValue({ email: user.email });
        this.memberForm.patchValue({
            email: user.email,
            id: user.id,
            role: user.role || '', // fallback to empty if role not present
            memberType: user.memberType || '',
            chapterAffiliation: user.chapterAffiliation || ''
        });
        this.showUserDropdown = false;
        this.filteredUsers = [];
    }

    hideDropdownWithDelay() {
        setTimeout(() => this.showUserDropdown = false, 200); // Delay to allow click
    }

    updateUser(): void {

        if (this.memberForm.valid) {
            const memberData = this.memberForm.value;

            this.usereApiService.updateProfile(memberData.id, memberData).subscribe({
                next: (data) => {
                    this.upsertUser(data);
                    this.memberForm.patchValue({
                        email: data.email || '',
                        id: data.id || '',
                        role: data.role || '',
                        memberType: data.memberType || '',
                        chapterAffiliation: data.chapterAffiliation || ''
                    });
                    this.toastr.success('User profile updated succesfully', 'Success');
                },
                error: (err) => {
                    console.error('Error creating committee:', err);
                    this.toastr.error('Failed to update User', 'Submission Failed');
                },
            });


        } else {
            this.toastr.error('Please fix the errors in the form.', 'Submission Failed');
        }
    }

    // Mirrors USER:UPDATE on the API (SYS_ADMIN, NEC_PRESIDENT, NEC); the API enforces it.
    get canEditFullProfile(): boolean {
        return this.allChapters;
    }

    get fullProfileKids(): FormArray {
        return this.fullProfileForm.get('kidDetails') as FormArray;
    }

    addFullProfileKid(kid?: any): void {
        this.fullProfileKids.push(this.fb.group({
            firstName: [kid?.firstName || ''],
            lastName: [kid?.lastName || ''],
            yearOfBirth: [kid?.yearOfBirth || '']
        }));
    }

    removeFullProfileKid(index: number): void {
        this.fullProfileKids.removeAt(index);
    }

    openFullProfileEditor(): void {
        const userId = this.memberForm.value.id;
        if (!userId) return;
        this.switchModal('modal-add-user-member', 'modal-edit-full-profile', () => this.loadFullProfile(userId));
    }

    private loadFullProfile(userId: string): void {
        this.fullProfileUserId = userId;
        this.fullProfileSubmitted = false;
        this.fullProfileForm.reset();
        this.fullProfileKids.clear();
        this.spinner.show();
        this.usereApiService.getData(userId).pipe(
            finalize(() => this.spinner.hide())
        ).subscribe({
            next: (user: any) => {
                this.fullProfileForm.patchValue(user);
                (user.kidDetails || []).forEach((kid: any) => this.addFullProfileKid(kid));
            },
            error: (err) => {
                console.error('Failed to load user profile', err);
                this.toastr.error('Failed to load user profile');
            }
        });
    }

    saveFullProfile(): void {
        if (!this.fullProfileUserId) return;
        this.fullProfileSubmitted = true;
        if (this.fullProfileForm.invalid) {
            this.fullProfileForm.markAllAsTouched();
            this.toastr.error('Please fill in the highlighted fields.', 'Submission Failed');
            this.focusFirstInvalidField();
            return;
        }
        this.spinner.show();
        this.usereApiService.updateProfileAsAdmin(this.fullProfileUserId, this.fullProfileForm.value).pipe(
            finalize(() => this.spinner.hide())
        ).subscribe({
            next: (data) => {
                this.upsertUser(data);
                this.toastr.success(`${data.firstname || ''} ${data.lastname || ''} profile updated`.trim(), 'Success');
                // @ts-ignore
                $('#modal-edit-full-profile').modal('hide');
            },
            error: (err) => {
                console.error('Failed to update full profile', err);
                this.toastr.error(typeof err?.error === 'string' ? err.error : 'Failed to update profile', 'Submission Failed');
            }
        });
    }

    // Spouse details only apply while married; children while married or divorced (same as the profile page).
    get showSpouseFields(): boolean {
        return this.fullProfileForm.get('maritalStatus')?.value === 'Married';
    }

    get showChildrenFields(): boolean {
        return ['Married', 'Divorced'].includes(this.fullProfileForm.get('maritalStatus')?.value);
    }

    isFullProfileFieldInvalid(name: string): boolean {
        const control = this.fullProfileForm.get(name);
        return !!control && control.invalid && (control.touched || this.fullProfileSubmitted);
    }

    get fullProfileMissingFields(): string[] {
        return Object.keys(this.fullProfileLabels)
            .filter(name => this.fullProfileForm.get(name)?.invalid)
            .map(name => this.fullProfileLabels[name]);
    }

    private focusFirstInvalidField(): void {
        const first = Object.keys(this.fullProfileLabels).find(name => this.fullProfileForm.get(name)?.invalid);
        if (!first) return;
        setTimeout(() => {
            const el = document.querySelector<HTMLElement>(`#modal-edit-full-profile [formControlName="${first}"]`);
            el?.scrollIntoView({behavior: 'smooth', block: 'center'});
            el?.focus();
        });
    }

    // Bootstrap can't stack these modals: open the next one only after the current one has fully closed.
    private switchModal(fromId: string, toId: string, beforeShow: () => void): void {
        const fromEl = document.getElementById(fromId);
        const toEl = document.getElementById(toId);
        if (!fromEl || !toEl) return;
        const onHidden = () => {
            beforeShow();
            document.body.classList.add('modal-open');
            // @ts-ignore
            $(toEl).modal('show');
            // @ts-ignore
            $(fromEl).off('hidden.bs.modal', onHidden);
        };
        // @ts-ignore
        $(fromEl).off('hidden.bs.modal').on('hidden.bs.modal', onHidden);
        // @ts-ignore
        $(fromEl).modal('hide');
        document.body.classList.remove('modal-open');
    }

    get paymentCompletedMembers() {
        return this.pendingMembers.filter(
            user => user.applicationStatus === 'PAYMENT_COMPLETE'
        );
    }

    // Real counts for the KPI row — no placeholder/estimated figures.
    get activeMemberCount(): number {
        return this.chapterUsers.filter(u =>
            ['MEMBER', 'LIFE_MEMBER', 'ANNUAL_MEMBER'].includes(u.memberType)
        ).length;
    }
    viewUserAndCloseCurrentModal() {
        const userId = this.memberForm.value.id;
        if (!userId) return;

        const addUserModalEl = document.getElementById('modal-add-user-member');
        const viewProfileModalEl = document.getElementById('modal-view-profile');

        if (!addUserModalEl || !viewProfileModalEl) return;

        // 1️⃣ Attach hidden event listener to ensure second modal opens only after first is gone
        const onHidden = () => {
            this.viewProfile(userId); // Load profile

            // Manually reset body overflow before showing new modal
            document.body.classList.add('modal-open');

            // @ts-ignore
            $(viewProfileModalEl).modal('show');

            // Clean up event listener
            // @ts-ignore
            $(addUserModalEl).off('hidden.bs.modal', onHidden);
        };

        // @ts-ignore
        $(addUserModalEl).off('hidden.bs.modal').on('hidden.bs.modal', onHidden);

        // 2️⃣ Hide first modal
        // @ts-ignore
        $(addUserModalEl).modal('hide');

        // 3️⃣ Manually remove modal-open class from body temporarily to avoid double scroll
        document.body.classList.remove('modal-open');
    }

    private loadUsers(): void {
        this.spinner.show(); // Show spinner while loading chapter users
        this.usereApiService.getUsers().pipe(
            finalize(() => this.spinner.hide()) // ✅ Hide spinner after outermost call completes
        ).subscribe({
            next: (response) => {
                this.chapterUsers = response;
                this.refreshPendingMembers();
            },
            error: (err) => {
                console.error('Failed to load chapter users', err);
            }
        });
    }

    private refreshPendingMembers(): void {
        // Filter: show only Non_member OR Pending
        this.pendingMembers = this.chapterUsers.filter(
            u => u.memberType === 'NON_MEMBER' || u.memberType === ''
        ).sort((a, b) => {
            // Sort descending by createDate
            const dateA = new Date(a.createDate || 0).getTime();
            const dateB = new Date(b.createDate || 0).getTime();
            return dateB - dateA; // descending: latest first
        });
    }

    private upsertUser(updatedUser: any): void {
        const index = this.chapterUsers.findIndex(u => u.id === updatedUser.id);
        if (index >= 0) {
            this.chapterUsers[index] = {
                ...this.chapterUsers[index],
                ...updatedUser
            };
        } else {
            this.chapterUsers.push(updatedUser);
        }
        this.refreshPendingMembers();
    }



}
